import React from "react";
import { DatePicker, Button, Form } from "antd";
import "moment/locale/en-nz";
import moment from "moment";

class ContributionDatePicker extends React.Component {
  render() {
    //let dateString = this.props.contributionDate.toLocaleString("en-NZ");
    const dateFormat = "DD-MM-YYYY";
    return (
      <div className="panel">
        <Form layout="inline">
          <Form.Item label="Date">
            <DatePicker
              allowClear={false}
              autoFocus={true}
              defaultValue={moment(this.props.contributionDate)}
              format={dateFormat}
              onChange={this.props.onChange}
            />
          </Form.Item>
          <Form.Item style={{ float: 'right' }} >
          <Button icon="plus" onClick={this.props.addNewRow}>Add</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default ContributionDatePicker;
